import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";

export const router = createBrowserRouter([
	{
		path: "/",
		element: <Layout />,
		children: [
			{ index: true, element: <Home /> },
			{ path: "login", element: <Login /> },
			{
				element: <ProtectedRoute />,
				children: [
					{ path: "products", element: <Products /> },
					{ path: "products/:id", element: <ProductDetail /> },
					{ path: "cart", element: <Cart /> },
					{ path: "checkout", element: <Checkout /> },
					{ path: "order/:id", element: <OrderConfirmation /> },
				],
			},
		],
	},
]);
